import { Component, OnInit } from '@angular/core';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiCallService } from '../../services/api-call.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { SessionUser } from 'src/app/shared/models/sessionUser';
import { Constanst } from '../../constants/constans.component';
import { HelperClassService } from '../../services/clase-utilidades.services';
import * as CryptoJS from 'crypto-js';
import { LocalStorageService } from '../../services/local-storage.service';
@Component({
  selector: 'app-login-card',
  templateUrl: './login-card.component.html',
  styleUrls: ['./login-card.component.css']
})
export class LoginCardComponent implements OnInit {

  hide = true;
  private method: string;
  private route: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  messageError: string = '';
  sessionUserLogged: SessionUser;
  consultDate: Date = new Date();

  isLoggedFailed: boolean = false;

  loginForm = new FormGroup ({
    username: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required])
  })

  constructor(
    private _router: Router,
    private apiCallService: ApiCallService,
    private helperClassService: HelperClassService,
    private localStorageService: LocalStorageService
  ) { }

  ngOnInit(): void {
  }

  login(valuesForm: any) {
    if (this.loginForm.invalid) {

      this.isLoggedFailed = false;

    } else {
      this.route = '/login';
      this.method = 'POST'

      let data = {
        userName: valuesForm.username,
        password: valuesForm.password,
        codAuthorized: this.localStorageService.getItem(Constanst.REMOTE_USE_CODE)
      }
      this.messageError = '';
      // this._router.navigate(['menu']);
      this.apiCallService.call$(data, this.route, this.method, false, '', true)
        .pipe(takeUntil(this.destroy$)).subscribe(
          response => {
            //console.log(response);
            if (response) {
              if (response.status === 'ERROR') {
                this.isLoggedFailed = true;
                switch (response.data.code) {
                  case 'MSG-002': {
                    this.messageError = Constanst.MSG_002;
                    this.apiCallService.hideSpinner();
                    break;
                  }
                  case 'MSG-003': {
                    this.messageError = Constanst.MSG_003;
                    this.apiCallService.hideSpinner();
                    break;
                  }
                  case 'MSG-004': {
                    this.messageError = Constanst.MSG_004;
                    this.apiCallService.hideSpinner();
                    break;
                  } case 'MSG-006': {
                    this.messageError = Constanst.MSG_006;
                    // this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_006, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
                    this.apiCallService.hideSpinner();
                    break;
                  } case 'MSG-012': {
                    this.messageError = Constanst.MSG_012;
                    this.apiCallService.hideSpinner();
                    break;
                  } default: {
                    //console.log('Error desconocido al autenticar: ', response.data.code)
                    this.apiCallService.hideSpinner();
                    this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
                    break;
                  }
                }
              } else {
                this.localStorageService.setItem(Constanst.STORAGE_DATA_CODE, response.data);
                this.localStorageService.setItem(Constanst.STORAGE_DATA_USER, response.user.idUser.toString());
                this.localStorageService.setItem(Constanst.STORAGE_DATA_FIRSTADMISSION, response.user.firstAdmission.toString());
                this.localStorageService.setItem(Constanst.STORAGE_DATA_PROFILE, response.profile.idProfile.toString());
                this.localStorageService.setItem(Constanst.STORAGE_DATA_USERNAME, valuesForm.username);
                localStorage.setItem(Constanst.STORAGE_DATA_CONSULTDATE, this.consultDate.toDateString());
                localStorage.setItem(Constanst.STORAGE_DATA_SCREENTYPE, Constanst.SCREEN_TYPE_BD);
                this.apiCallService.hideSpinner();
                this._router.navigate(['menu']);
              }
            }
          },
          error => {
            //console.log('Falla al autenticar al usuario ', error)
            this.apiCallService.hideSpinner();
            this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
          }
      );
    }
  }

  forgotPassword() {
    this._router.navigateByUrl('/forgotPassword');
  }

}
